module.exports = "https://web-assets.ifttt.com/packs/media/settings/icon-avatar-c9a45d64.svg";